import { useEffect, useRef, useState } from "react"
import { Box, Separator, Stack } from "@chakra-ui/react"
import { ClientListItem, Section, Text } from "@/components"
import { EsoClient } from "@/types"

const PAGE_SIZE = 50

interface Props {
  isLoading: boolean
  clients: EsoClient[]
}

export const ClientsComponent = ({ isLoading, clients }: Props) => {
  
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE)

  const loadMoreRef = useRef<HTMLDivElement | null>(null)
  const scrollRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!loadMoreRef.current || !scrollRef.current) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisibleCount((prev) =>
            Math.min(prev + PAGE_SIZE, clients.length)
          )
        }
      },
      {
        root: scrollRef.current,
        threshold: 1
      }
    )

    observer.observe(loadMoreRef.current)

    return () => observer.disconnect()
  }, [clients.length])

  const visibleClients = clients.slice(0, visibleCount)

  return (
    <Section>
      <Text fontSize="2xl" fontWeight="bold">
        Your Clients
      </Text>
      <Separator />
      <Stack
        ref={scrollRef}
        mt={5}
        px={{ base: 2, md: 10 }}
        overflowY="auto"
        flex="1"
        minH={0}
      >
        {visibleClients.map((client: EsoClient) => (
          <ClientListItem key={client.id} client={client} />
        ))}

        {visibleCount < clients.length && (
          <Box ref={loadMoreRef} height="40px" />
        )}
      </Stack>
    </Section>
  )
}
